import { createSlice } from "@reduxjs/toolkit";
import { notificationApi } from "../../middleware/notificationApi";
const initialState = {
  notificationCount: 0,
};

export const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      notificationApi.endpoints.getNotificationsCount.matchFulfilled,
      (state, { payload }) => {
        state.notificationCount = payload;
      }
    );
  },
});

export const notificationActions = notificationSlice.actions;
export const notificationReducer = notificationSlice.reducer;
